import type { PurchaseStep } from "@app/types/checkout-types";
import type { PublicState } from "@app/types/napi-types";

import { PURCHASE_STATES, PURCHASE_STEPS_NAMES } from "../constants";

/**
 * Get the most appropriate Purchase Step for the given Purchase State received from the backend.
 *
 * @param purchase_state
 * @returns
 */
export function getPurchaseStepForState(
  purchase_state: PublicState | null
): PurchaseStep {
  switch (purchase_state) {
    case PURCHASE_STATES.VALIDATE:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.VALIDATE;
    case PURCHASE_STATES.RESERVE:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.RESERVE;
    case PURCHASE_STATES.AUTHORIZE:
    case PURCHASE_STATES.REDIRECT_USER:
    case PURCHASE_STATES.IDENTIFY_USER:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.AUTHORIZE;
    case PURCHASE_STATES.DERISK:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.DERISK;
    case PURCHASE_STATES.BOOK:
    case PURCHASE_STATES.CAPTURE:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.BOOK;
    case PURCHASE_STATES.COMPLETE:
    case PURCHASE_STATES.DELAYED:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.COMPLETED;
    default:
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      return PURCHASE_STEPS_NAMES.NOT_STARTED;
  }
}
